import { render, staticRenderFns } from "./iconDinersClub.vue?vue&type=template&id=17efed0a&scoped=true"
import script from "./iconDinersClub.vue?vue&type=script&lang=js"
export * from "./iconDinersClub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17efed0a",
  null
  
)

export default component.exports